// extracted by mini-css-extract-plugin
export default {"tab-radio":"TabRadio_tab-radio__WHHlh","title":"TabRadio_title__CEXDG","radios":"TabRadio_radios__yphVy","content":"TabRadio_content__ciRDB"};